/**
 * File: StatCard.js
 * Origin: isotect
 * Description: StatCard component renders a statistic card.
 *
 * Version: v1.0.0
 * Created: 2026-04-25
 * Last Updated: 2026-05-01
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * StatCard component renders a statistic with a label and value.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {string} props.label - Label for the statistic
 * @param {string|value} props.value - Value of the statistic
 *
 * @returns {JSX.Element} A stat card element displaying a label and value
 */
function StatCard({ label, value }) {
    return (
        <>
            <div className="stat-card">
                <p className="stat-card__label">{label}</p>
                <p className="stat-card__value">{value}</p>
            </div>
        </>
    );
}

export default StatCard;
